// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.
// Copiado do exemplo em https://github.com/hopsoft/chatter/blob/master/app/javascript/channels/index.js

const channels = require.context('.', true, /_channel\.js$/)
channels.keys().forEach(channels)